export default {
    zh: {
        title: '智能客服',
        status: '在线 · 全天候服务',
        welcome: '你好！👋 欢迎来到我们的客服中心，请问有什么可以帮您？',
        inputPlaceholder: '请输入您的问题...',
        errorMsg: '抱歉，系统出现问题，请重试。',
        networkError: '网络连接失败，请检查网络后重试。'
    },
    en: {
        title: 'Customer Support',
        status: 'Online · 24/7 Available',
        welcome: 'Hello! 👋 Welcome to our customer support. How can I help you today?',
        inputPlaceholder: 'Type your message...',
        errorMsg: 'Sorry, something went wrong. Please try again.',
        networkError: 'Connection error. Please check your network and try again.'
    },
    ja: {
        title: 'カスタマーサポート',
        status: 'オンライン · 24時間対応',
        welcome: 'こんにちは！👋 カスタマーサポートへようこそ。何かお手伝いできますか？',
        inputPlaceholder: 'メッセージを入力...',
        errorMsg: '申し訳ございません。エラーが発生しました。もう一度お試しください。',
        networkError: '接続エラー。ネットワークを確認して再試行してください。'
    },
    ko: {
        title: '고객 지원',
        status: '온라인 · 24시간 이용 가능',
        welcome: '안녕하세요! 👋 고객 지원에 오신 것을 환영합니다. 무엇을 도와드릴까요?',
        inputPlaceholder: '메시지를 입력하세요...',
        errorMsg: '죄송합니다. 문제가 발생했습니다. 다시 시도해 주세요.',
        networkError: '연결 오류. 네트워크를 확인하고 다시 시도해 주세요.'
    },
    es: {
        title: 'Atención al Cliente',
        status: 'En línea · Disponible 24/7',
        welcome: '¡Hola! 👋 Bienvenido a nuestro soporte al cliente. ¿Cómo puedo ayudarte hoy?',
        inputPlaceholder: 'Escribe tu mensaje...',
        errorMsg: 'Lo sentimos, algo salió mal. Por favor, inténtalo de nuevo.',
        networkError: 'Error de conexión. Por favor, verifica tu red e inténtalo de nuevo.'
    },
    fr: {
        title: 'Support Client',
        status: 'En ligne · Disponible 24h/24',
        welcome: 'Bonjour ! 👋 Bienvenue dans notre support client. Comment puis-je vous aider aujourd\'hui ?',
        inputPlaceholder: 'Écrivez votre message...',
        errorMsg: 'Désolé, une erreur est survenue. Veuillez réessayer.',
        networkError: 'Erreur de connexion. Veuillez vérifier votre réseau et réessayer.'
    },
    de: {
        title: 'Kundensupport',
        status: 'Online · 24/7 verfügbar',
        welcome: 'Hallo! 👋 Willkommen bei unserem Kundensupport. Wie kann ich Ihnen heute helfen?',
        inputPlaceholder: 'Nachricht eingeben...',
        errorMsg: 'Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        networkError: 'Verbindungsfehler. Bitte überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.'
    },
    pt: {
        title: 'Suporte ao Cliente',
        status: 'Online · Disponível 24/7',
        welcome: 'Olá! 👋 Bem-vindo ao nosso suporte ao cliente. Como posso ajudá-lo hoje?',
        inputPlaceholder: 'Digite sua mensagem...',
        errorMsg: 'Desculpe, algo deu errado. Por favor, tente novamente.',
        networkError: 'Erro de conexão. Verifique sua rede e tente novamente.'
    },
    ru: {
        title: 'Служба поддержки',
        status: 'Онлайн · Круглосуточно',
        welcome: 'Здравствуйте! 👋 Добро пожаловать в нашу службу поддержки. Чем могу помочь?',
        inputPlaceholder: 'Введите сообщение...',
        errorMsg: 'Извините, произошла ошибка. Пожалуйста, попробуйте снова.',
        networkError: 'Ошибка соединения. Проверьте сеть и попробуйте снова.'
    },
    ar: {
        title: 'دعم العملاء',
        status: 'متصل · متاح على مدار الساعة',
        welcome: 'مرحباً! 👋 مرحباً بك في دعم العملاء. كيف يمكنني مساعدتك اليوم؟',
        inputPlaceholder: 'اكتب رسالتك...',
        errorMsg: 'عذراً، حدث خطأ. يرجى المحاولة مرة أخرى.',
        networkError: 'خطأ في الاتصال. يرجى التحقق من شبكتك والمحاولة مرة أخرى.'
    }
}